import React from 'react';
import { Button, Container, Text } from 'basis';
import styled from '@emotion/styled';
import { Modal } from 'components/modal/Modal';
import { formatNumber } from 'utils';

export const AmountAlertModal = ({ isOpen, onClose, maximumAmount }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} style={{ maxWidth: 600 }}>
      <Container padding="9">
        <FlexCenter gap="6">
          <Text textStyle="heading5">Reduce your balance transfer amount</Text>
          <Text>
            Your total balance transfer amount is over the ${formatNumber(maximumAmount.toLocaleString())} limit.
          </Text>
          <Text>Reduce it to continue.</Text>
          <Button testId="alert-modal-edit-button" type="button" onClick={onClose}>
            Edit balance transfer
          </Button>
        </FlexCenter>
      </Container>
    </Modal>
  );
};

export const DebtAlertModal = ({ isOpen, onClose, onClick }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} style={{ maxWidth: 600 }}>
      <Container padding="9">
        <FlexCenter gap="6">
          <Text textStyle="heading5">Add your credit card details</Text>
          <Text>
            To continue, return to Financial commitments and enter your <strong>Amount owing on credit card/s.</strong>
          </Text>
          <Button testId="alert-modal-edit-button" type="button" onClick={onClick}>
            Back to Financial Commitments
          </Button>
        </FlexCenter>
      </Container>
    </Modal>
  );
};

const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;
